export const PAYMENTS_SET_PAYMENT = (state, { payment }) => ({
  ...state,
  payment
});

export const PAYMENTS_CLEAR_PAYMENT = (state) => ({
  ...state,
  payment: undefined
});

export const PAYMENTS_SET_MESSAGE = (state, { details, message }) => ({
  ...state,
  message: { value: message, details }
});

export const PAYMENTS_CLEAR_MESSAGE = (state) => ({
  ...state,
  message: undefined
});

export const PAYMENTS_SET_ACTION_MESSAGES = (state, { paymentActionMessages }) => ({
  ...state,
  paymentActionMessages
});

export const PAYMENTS_CLEAR_ACTION_MESSAGES = (state) => ({
  ...state,
  paymentActionMessages: null
});

export const PAYMENTS_CLEAR_ACTION_MESSAGE = (state, { id }) => ({
  ...state,
  paymentActionMessages: state.paymentActionMessages.filter((message) => message.id !== id)
});

export const PAYMENTS_SET_SMB_HIGHLIGHT_ROWS = (state, { highlightedRows }) => ({
  ...state,
  highlightedRows
});

export const PAYMENTS_SET_IMPORT_GRID_MESSAGES = (state, { importGridMessages }) => ({
  ...state,
  importGridMessages
});
